document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product__grid__info').forEach(function(info) {
    var productLink = info.querySelector(':scope > a'); // direct child <a>
    if (productLink) {
      var newView = document.createElement('a');
      newView.className = 'view-prod-btn';
      newView.href = productLink.href;
      newView.textContent = 'View Product';
      info.appendChild(newView);
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("label.color-swatch").forEach(function (swatch) {
    swatch.addEventListener("click", function () {
      const input = swatch.previousElementSibling;
      if (!input || input.tagName.toLowerCase() !== "input") return;

      // Normalize the value (trim + lowercase) for safer matching
      const v = String(input.value || "").trim().toLowerCase();

      // Limit the query to the product card the swatch belongs to
      const card = swatch.closest(".product-grid-item");

      // Toggle visibility of all buttons with data-label inside the card
      card.querySelectorAll("button[data-label]").forEach(function (btn) {
        const label = String(btn.getAttribute("data-label")).trim().toLowerCase();
        if (label === v) {
          btn.classList.remove("hidden");
        } else {
          btn.classList.add("hidden");
        }
      });
    });
  });
});
